module.exports = __webpack_public_path__ + "static/img/1958_05_16_NYTimes_Review.3a1a74c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_16_NYTimes_Review.jpg
// module id = 87E6
// module chunks = 0